import { format } from 'date-fns';

class MetadataOnSave {
    
    elements = {};

    constructor(elements = {}) {
        this.elements = { ...elements };
    }
    
    onStateChange = (changedElements) => {
        console.log(this.elements, changedElements);
        if(this.elements.hasOwnProperty("published") && changedElements.hasOwnProperty("published")) {
            console.log(this.elements.published, changedElements.published);
            if(this.elements.published !== changedElements.published) {
                if(changedElements.published === "1") {
                    console.log("THERE");
                    let now = format(new Date(), 'yyyy-MM-dd HH:mm:ss');
                    changedElements.txt13 = now;
                }
            }
        }
        
        return changedElements;
    }
}

export default MetadataOnSave;


